import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import useUserPermissions from "@hooks/useUserPermissions";
import { AnalyticsPage } from "src/pages/analytics/AnalyticsPage";
// import { HVLoader } from "@repo/HVComponents";

const Dashboard = lazy(() => import("../pages/dashboard"));
const Report = lazy(() => import("../pages/report"));
const DeviceSetup = lazy(() => import("../pages/setup/device/device-setup"));
const User = lazy(() => import("../pages/setup/user/user"));
const Roles = lazy(() => import("../pages/setup/user/roles"));
const Page403 = lazy(() => import("../pages/error-pages/page403"));
const Page404 = lazy(() => import("../pages/error-pages/page404"));
const Setup = lazy(() => import("src/pages/setup"));
const ProtectPage = lazy(() => import("@components/page-wrapper/ProtectPage"));

export const Router = () => {
  const {
    isUserAccessibleSettings,
    isUserAccessibleAnalytics,
    isUserAccessibleReport
  } = useUserPermissions();
  return (
    <Suspense>
      <Routes>
        <Route element={<ProtectPage />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboards/:urlDashboardId" element={<Dashboard />} />
          <Route
            path="/reports"
            element={isUserAccessibleReport() ? <Report /> : <Page403 />}
          />
          <Route
            path="/settings"
            element={isUserAccessibleSettings() ? <Setup /> : <Page403 />}
          >
            <Route path="/settings/devices/devices" element={<DeviceSetup />} />
            {/* <Route path="/setup/user/admin" element={<Admin />} /> */}
            <Route path="/settings/users/users" element={<User />} />
            <Route path="/settings/users/roles" element={<Roles />} />
          </Route>
          <Route
            path="/analytics"
            element={
              isUserAccessibleAnalytics() ? <AnalyticsPage /> : <Page403 />
            }
          />
          <Route path="/forbidden" element={<Page403 />} />
          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
